import React, { useEffect, useState } from 'react';
import '../App.css';
import Layout from '../components/Layout';
import SideNav from '../components/SideNav';

const SmartService = () => {
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const contentSections = [
    {
      title: '一卡通中心',
      content: '一卡通管理系统以"智慧校园一体化"建设理念为核心，建立统一的数据标准，通过云计算、移动支付等新兴技术重点解决学校内部校园卡管理、电子学生证管理、刷卡消费结算、水电使用管理以及校园卡与智慧校园各应用系统的对接问题。系统主要由卡务、用水和用电三大平台组成，涵盖了智能制卡、水电设备管理、校园消费、水电退费、数据统计分析等功能模块。',
      img:   <img src="/src/img/yktzx.png" alt="" />  
    },
    {
      title: '综合管线管理系统',
      content: '通过全面整合所有接入设备，统计全校设备的数量及使用情况，对校园的各类场所及设备的可视化呈现和统一管控，减轻管理员的工作负担，提高管理效率；同时融合设备远程控制、智能管控策略、设备故障反馈等功能，确保校园设备能高效稳定运行，最终实现校园设备跨校区、跨网段、多教学场景的统一监控和管理。',
      img:   <img src="/src/img/zhgxgl.png" alt="" />
    },
    {
      title: '能耗监测管理系统',
      content: '基于物联网技术，采用一体化设计而构建的校园能耗监测管理系统，旨在提高学校能源管理的效率和精确度。系统自动同步智慧校园中校区、楼宇及设备档案信息，并基于数字化的环境档案对校园内水、电、气等能耗数据进行全域监测和自动化采集，不仅为用户提供能耗费用统计、能耗流向分析、能耗用量预警等服务，同时支持远程开关小流量水电计量设备，并实现了楼宇用能分析和设备用能分析，为用户精准定位节能改造重点区域，从而进一步提高能源利用效率，减少碳排放，促进双碳背景下的绿色校园建设。',
      img:   <img src="/src/img/nhjcgl.png" alt="" />
    },
    {
      title: '消费管理系统',
      content: '为学生、教职工等建立消费账户，可进行充值、挂失、解挂、补办等操作。支持多种支付方式，如刷卡、扫码、刷脸等，方便快捷。支持食堂就餐、超市购物、水电缴费等多种场景的支付。学生或家长可以通过系统进行在线充值，避免了现金充值的麻烦。用户能够查看自己的详细消费记录，包括消费时间、地点、金额等信息。对消费数据进行统计和分析。生成各类消费报表，有助于学校进行财务管理和审计。设置不同用户的权限，如管理员、操作员等，确保系统的安全性和数据的保密性。针对学校超市等场所，可进行商品信息的录入、修改、查询等操作。实现对学生的补贴发放，如餐补等，并记录相关信息。对消费终端设备（如刷卡机、扫码器等）进行管理和维护。还可以进行通知与提醒，提醒学生账户余额不足、充值成功通知等。',
      img:   <img src="" alt="" />
    },
    {
      title: '考勤管理系统',
      content: '教学活动管理系统，融合了计算机视觉和人工智能技术，通过实时采集、检测、识别学生人脸信息，有效协助教师简化学生出勤记录流程，提升课堂教学效率和管理水平。此外，系统具备丰富的考勤数据分析功能，使教师、学生和管理员能轻松查看自身权限范围内的考勤情况，并可及时申诉或处理异常记录。通过与课表联动以及整合分析考勤数据，为学校带来了全面、便捷、安全的课堂考勤体验，满足了现代教育管理的需求。',
      img:   <img src="/src/img/kqgl.png" alt="" />
    },
    {
      title: '门禁闸机管理系统',
      content: '通过在学校大门安装通道机、人脸识别设备，实现人员快速通行，对学生进出校园信息有效控制和统计。系统自动识别并推送消息通知家长，从而达到家长对学生出入校门信息的实时监控，实现保障学生在校安全的目的。门禁设备可以和请销假系统、访客系统、宿管系统进行联动，核身放行，实现数据互通。',
      img : <img src="/src/img/mjzjgl.png" alt="" /> 
    },
    {
      title: '校园广播系统',
      content: '校园广播系统是校园文化建设的重要载体，其融合了传统音频广播和现代化远程信息发布技术，配套资源丰富的广播媒体库，支持多媒体信息广播、校园直播、IP网络音频广播以及第三方直播流转播，实现校园文化及舆论宣传的定时广播、定向广播、自动循环启停、一键紧急告警以及广播设备的远程管理控制。此外，管理员及校领导还可通过校园广播微信小程序及相关APP应用实现校园广播的移动化管理，保证校园广播信息发布的统一、及时和有效，建立校园广播的宣传机制。',
      img : <img src="/src/img/xygb.png" alt="" />
    },
    {
      title: '校园监控系统',
      content: '校园监控系统是指利用一系列的监控设备、技术和软件，对学校的教学区域、活动场所、出入口、宿舍、食堂等关键位置进行实时监测和记录的综合系统。该系统通常包括前端的摄像头、传感器等设备，用于采集图像和数据；中间的传输网络，将采集到的信息传输至后端的存储和处理设备；后端则包括数据存储服务器、监控管理平台等，用于对数据进行存储、分析和管理。',
      img : <img src="/src/img/xyjk.png" alt="" />
    },
    {
      title: '心理健康平台',
      content: '身心健康智能预警预测平台通过大数据技术智能预警预测，实时掌握学生失联、挂科等异常信息，及时发现学生心理、行为变化，前置开展疏导教育，将学生安全事故防患于未然。',
      img : <img src="/src/img/xljkpt.png" alt="" />
    },
    {
      title: '校园安全大平台',
      content: '主要通过视频监控设备和软件，利用视频分析、人工智能等技术，智能化地对校园监控场景下的图像、视频记录进行识别、分析，实时、准确采集校园异常行为数据信息。系统可集成到校园安全中心平台，并联动访客、门禁、车辆管理、校园广播、能耗监测、设备管控等子系统，实现校园安防异常、用电异常以及烟雾、可燃气体浓度的实时监测与告警，同时具备远程语音指挥调度功能，形成校园安防整治、监督指挥、安全评估、智能管理的新模式，全面构建人防、物防、技防三位一体的平安校园监管体系。',
      img : <img src="/src/img/xyaqdpt.png" alt="" />
    }
  ];

  const handleSectionChange = (index) => {
    setActiveSection(index);
  };

  return (
    <Layout>
      <div className="page-header" style={{ 
        backgroundImage: 'url("/src/img/zhmkt.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <h1 style={{ 
          color: '#fff',
          fontSize: '2.5rem',
          fontWeight: 'bold',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>智慧服务系统</h1>
      </div>
      <div className="page-container">
        <div className="page-layout">
          <div className="left-menu">
            {contentSections.map((section, index) => (
              <div
                key={index}
                className={`menu-item ${activeSection === index ? 'active' : ''}`}
                onClick={() => handleSectionChange(index)}
              >
                {section.title}
              </div>
            ))}
          </div>
          <div className="content-section">
            <div className="section-header" style={{
              padding: '20px 40px',
              marginBottom: '30px'
            }}>
              <h3 style={{
                fontSize: '1.2rem',
                lineHeight: '1.6',
                color: '#333',
                textIndent: '2em'
              }}>{contentSections[activeSection].content}</h3>
            </div>
            <div className="service-content">
              <div className="service-features" style={{ display: 'flex', justifyContent: 'center', height: '500px', marginBottom: '40px' }}>
                <div style={{ width: '1000px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                  {contentSections[activeSection].img && React.cloneElement(contentSections[activeSection].img, {
                    style: { width: '100%', height: '100%', objectFit: 'contain' }
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SmartService;